const axios = require('axios');
//import axios from 'axios';
class Service {
  #httpHandler;
  #nsdToken;
  #addToken;
  #getCookie;
  constructor(baseUrl, nsdToken) {
    console.log(`ACE: ${baseUrl} ${nsdToken}`);
    this.#nsdToken = nsdToken;
    this.#addToken = this.addCookieTokenToRequest;
    this.#getCookie = this.getCookie;
    this.#httpHandler = axios.create({
      headers: {
        common: {
          'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY,
          Origin: 'http://localhost'
        }
      },
      withCredentials: true,
      baseURL: baseUrl || null
    });

    console.log(
      `ACE HEADER: ${JSON.stringify(this.#httpHandler.defaults, null, 2)}`
    );
    this.#httpHandler.interceptors.response.use(
      this.handleSuccess,
      this.handleError
    );
    this.#httpHandler.interceptors.request.use(
      this.handleConfig,
      this.handleError
    );
  }

  //#region Handlers
  handleConfig(config) {
    let getCookie = cname => {
      let name = cname + '=';
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    };

    let addCookieTokenToRequest = config => {
      let token = getCookie('nsd.token');
      config.headers.common = {
        ...config.headers.common,
        ...{ Authorization: `Bearer ${token}` }
      };
      console.log(
        `ACE HEADER: ${JSON.stringify(config.headers.common, null, 2)}`
      );
    };
    addCookieTokenToRequest(config);
    return config;
  }

  handleSuccess(response) {
    return response;
  }

  handleError = error => {
    const responseStatus = error?.response?.status;
    switch (responseStatus) {
      case 401:
        console.log(`ACE 401: ${JSON.stringify(error, null, 2)}`);
        break;
      case 404:
        console.log(`ACE 404: ${JSON.stringify(error, null, 2)}`);
        break;
      default:
        console.log(`ACE: ${JSON.stringify(error, null, 2)}`);
        break;
    }
    return Promise.reject(error);
  };

  //#endregion

  //#region Http Verbs
  async get(path) {
    const response = await this.#httpHandler.get(path);
    return { status: response.status, data: response.data };
  }

  async patch(path, payload) {
    const response = await this.#httpHandler.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    });

    return { status: response.status, data: response.data };
  }

  async post(path, payload) {
    const response = await this.#httpHandler.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });

    return { status: response.status, data: response.data };
  }
  //#endregion
}

export default Service;
